/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import UCButton from "../../buttons";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
import { useLoyaltyService } from "../../../services/loyaltyService";

/* Components */

/* Styles */
import styles from "./styles.js";
import { colors } from "../../../constants/colors";

const Content = (props) => {
  const { setShowModal, redeemData, setAssignModalShow, allotmentId, onRedeemCompleted } = props;

  const { addRedemption } = useLoyaltyService();

  const theme = useTheme();
  const classes = styles({ theme });

  const filteredData = redeemData.map(({ userEntityId, tierLevel }) => ({
    userEntityId: userEntityId,
    tierLevel: tierLevel.toString(),
  }));

  const handleRedeem = async () => {
    const success = await addRedemption(allotmentId, {redemptions: filteredData});
    if (success) {
      setAssignModalShow(false);
      if (typeof onRedeemCompleted === 'function') onRedeemCompleted();
    }
  };

  return (
    <div>
      <br />
      <FormattedMessage id="confirmRedemptionModal.placeholder" />
      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={() => setShowModal(false)}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="confirmRedemptionModal.cancel" />}
              />
            </Col>
            <Col className={classes.colRedeem}>
              <UCButton
                className={classes.redeemBtn}
                onClick={handleRedeem}
                type="primary"
                text={<FormattedMessage id="confirmRedemptionModal.redeem" />}
                spinner={{
                  name: "addRedemptionSpinner",
                  size: 20,
                  color: colors.white,
                }}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  );
};

export default Content;
